import { PropositionBarClientData } from "types/PropoisitionBarData";
const trustpilotLogo =
  "https://megaweb-media.ao.com/ao.web.propositionbar.widget/images/trustpilot_logo.svg";
const punkteLogo =
  "https://megaweb-media.ao.com/ao.web.propositionbar.widget/images/payback_icon.svg";
const trustedShopLogo = "https://megaweb-media.ao.com/ao.web.propositionbar.widget/images/trustedshops_logo.svg";

export const breakpoints = {
  sm: 544,
  md: 768,
  lg: 990,
  xl: 1200,
};

export const settings: PropositionBarClientData = {
  AOL: {
    fullBp: breakpoints.xl,
    shrinkTextBp: breakpoints.lg,
    data: [
      {
        icon: "ico-price-match",
        text: "Price match promise",
        link: "/help-and-advice/Help-With-My-Order/price-match-promise/",
        dataTag: "WT.z_MMTab=pricematchpromise",
        dataTestId: "price-match-link",
      },
      {
        icon: "ico-100-days-return",
        text: "Free 100 day returns",
        link: "/help-and-advice/delivery-and-services/returns/",
        dataTag: "WT.z_MMTab=Returns",
        dataTestId: "returns-link",
      },
      {
        img: trustpilotLogo,
        text: "Rated Excellent",
        link: "https://www.trustpilot.com/review/www.ao.com",
        dataTag: "WT.z_MMTab=Trustpilot",
        linkNewTab: true,
        dataTestId: "trust-pilot-link",
      },
      {
        icon: "ico-delivery",
        text: "Next day delivery, 7 days a week",
        link: "/help-and-advice/delivery-and-services/delivery/",
        dataTag: "WT.z_MMTab=Delivery",
        dataTestId: "delivery-link",
      },
      {
        icon: "ico-finance-gbp",
        text: "Pay with AO Finance",
        link: "/help-and-advice/finance-and-savings/ao-finance/",
        dataTag: "WT.z_MMTab=Finance",
        dataTestId: "finance-link",
      },
    ],
  },
  ADE: {
    fullBp: breakpoints.xl,
    shrinkTextBp: breakpoints.sm,
    data: [
      {
        img: trustedShopLogo,
        text: "Trusted Shops – sehr gut bewertet",
        link: "/hilfe-service/ueber-uns-ao/trusted-shops",
        dataProposition: "trusted-shop",
        dataTestId: "trusted-shop-link",
      },      
      {
        icon: "ico-returns",
        text: `30 Tage Rückgabegarantie <br class='hidden xl:block' />Stressfrei & kostenlos`,
        link: "/hilfe-service/rueckgabegarantie",
        dataProposition: "returns",
        dataTestId: "returns-link",
      },
      {
        icon: "ico-delivery",
        text: "GRATIS Standardlieferung",
        link: "/hilfe-service/lieferung-und-services",
        dataProposition: "delivery",
        dataTestId: "delivery-link",
      },
      {
        icon: "ico-price-match-euro",
        text: `Shop-Award Gewinner <br class='hidden xl:block' />Bester Kundenservice`,
        link: "/hilfe-service/ueber-uns-ao/shop-award-2020",
        dataProposition: "trophy",
        dataTestId: "trophy-link",
      },
      {
        img: punkteLogo,
        text: "PAYBACK Punkte",
        link: "/hilfe-service/ueber-uns-ao/payback",
        dataProposition: "payback",
        dataTestId: "payback-link",
      },
    ],
  },
  TUK: {
    fullBp: breakpoints.xl,
    shrinkTextBp: breakpoints.lg,
    data: [
      {
        icon: "ico-delivery",
        text: "Next day delivery and installation",
        link: "/advice/delivery-and-installation",
        dataTag: "WT.z_MMTab=Delivery",
        dataTestId: "delivery-link",
      },
      {
        icon: "ico-price-match",
        text: "Price match promise",
        link: "/advice/price-match-promise/",
        dataTag: "WT.z_MMTab=pricematchpromise",
        dataTestId: "price-match-link",
      },
      {
        icon: "ico-finance-gbp",
        text: "Simple payments incl BACS",
        link: "/advice/payment",
        dataTag: "WT.z_MMTab=Payments",
        dataTestId: "payments-link",
      },
      {
        icon: "ico-recycling",
        text: "Recycling responsibly",
        link: "/advice/recycling",
        dataTag: "WT.z_MMTab=Recycling",
        dataTestId: "recycling-link",
      },
    ],
  },
};

export const carouselSettings = {
  index: 0,
  delay: 3000,
  transition: 300,
  interval: 4000, // interval + transition*2 + delay
};
